import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-new-button',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './new-button.component.html',
  styleUrls: ['./new-button.component.scss'],
})
export class NewButtonComponent {
  @Input() link!: string;
  @Input() text: string = 'Nuevo';
}
